import { Injectable, NgZone } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot } from '@angular/router';
import { NavController } from '@ionic/angular';
import { CheckoutLeaveCoordinator } from './checkout-leave-coordinator';
import { checkoutRecoveryEnabled } from './checkout-recovery-lever';

// Angular wrapper around CheckoutLeaveCoordinator (see that file for the
// semantics). Registered as canDeactivate on penmates/:id/messenger.

const activeCheckoutDraftId = (): string | null => {
  // Kill lever off: the guard sees no active checkout and every leave
  // proceeds untouched.
  if (!checkoutRecoveryEnabled()) return null;
  try {
    const v = (window as any).__pmreact_checkout_draft_id;
    return v ? String(v) : null;
  } catch (e) {
    return null;
  }
};

@Injectable({ providedIn: 'root' })
export class CheckoutLeaveGuard implements CanDeactivate<unknown> {
  private readonly coordinator: CheckoutLeaveCoordinator;

  constructor(
    private navCtrl: NavController,
    private zone: NgZone,
  ) {
    this.coordinator = new CheckoutLeaveCoordinator({
      now: () => Date.now(),
      target: window,
      activeDraftId: activeCheckoutDraftId,
      navigateBack: (url: string) =>
        new Promise<boolean>((resolve) => {
          this.zone.run(() => {
            this.navCtrl.navigateBack(url).then(
              (ok) => resolve(ok !== false),
              () => resolve(false),
            );
          });
        }),
    });
  }

  markHeaderBack(): void {
    this.coordinator.markHeaderBack();
  }

  canDeactivate(
    _component: unknown,
    _currentRoute: ActivatedRouteSnapshot,
    _currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot,
  ): boolean | Promise<boolean> {
    return this.coordinator.canLeave(nextState && nextState.url ? nextState.url : null);
  }
}
